module.exports = __webpack_public_path__ + "img/menu-blue.deedddc0.svg";